import './assets/style.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import * as Sentry from '@sentry/vue'

// VueFire - Firebase
import { VueFire } from 'vuefire'
import { firebaseApp } from '@/config/firebase'

//Lottiefiles
import { DotLottieVue } from '@lottiefiles/dotlottie-vue'

//theme
import 'primevue/resources/themes/lara-light-indigo/theme.css'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { md3 } from 'vuetify/blueprints'

// Mdi icons
import '@mdi/font/css/materialdesignicons.css'

import App from './App.vue'
import router from './router'

// Custom locales
import en from './locales/en_us.locale'
import pt from './locales/pt_br.locale'

import VueMathjax from 'vue-mathjax-next'

// Directives
import NotNegativeNumber from './directives/not-negative-number'
import InputCep from './directives/input-cep'
import MaxGrade from './directives/max-grade'
import Environment from './config/environment'
import VGrade from './directives/v-grade'
import TinymceComponent from '@/components/tinymce/TinymceComponent.vue'
import PrimeVue from 'primevue/config'
import Calendar from 'primevue/calendar'

const vuetify = createVuetify({
  blueprint: md3,
  components,
  directives,
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#336AE9',
          blue: '#336AE9',
          background: '#F7F7F7',
          surface: '#FCFCFC',
          'azul-90': '#B8C8EE',
          'preto-90': '#E6E6E6',
          'preto-100': '#FFF',
          'azul-cinza': '#B8C8EE',
          'azul-50': '#336AE9',
          'azul-99': '#B8C8EE'
        }
      }
    }
  },
  locale: {
    locale: 'pt',
    fallback: 'en',
    messages: { en, pt },
    rtl: {
      customLocale: true
    }
  }
})

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

Sentry.init({
  app,
  dsn: Environment.SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /pruvo\.app/gm, /professor-pruvo-v2/g],
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.1
})

app.use(pinia).use(router).use(vuetify).use(VueFire, { firebaseApp }).use(VueMathjax)

// Register PrimeVue and Calendar globally
app.use(PrimeVue)
app.component('PrimeCalendar', Calendar)

// Global Components
app.component('TinymceComponent', TinymceComponent).component('LottieFile', DotLottieVue)
app
  .directive('cep', InputCep)
  .directive('max-grade', MaxGrade)
  .directive('not-negative-number', NotNegativeNumber)
  .directive('grade', VGrade)

app.mount('#app')

app.config.errorHandler = async (error, vm, info) => await registerLog(error, info, 'ERROR')

app.config.warnHandler = async (error, vm, info) => await registerLog(error, info, 'WARN')

async function registerLog(error: any, info: string, severity: 'ERROR' | 'WARN') {
  try {
    console.log(error)
  } finally {
    // logging removido
  }
}
